<template>
  <div class="main-container">
    <el-row v-loading.fullscreen.lock="loading" element-loading-text="努力加载中"
      element-loading-background="rgba(255, 255, 255, 1)">
      <el-col :span="24" :xs="24" :sm="24" :md="{ span: 22, offset: 1 }" :lg="{ span: 22, offset: 1 }"
        :xl="{ span: 22, offset: 1 }">
        <template v-if="articleList.length === 0">
          <el-empty description="这里什么都没有"></el-empty>
        </template>
        <template v-else v-for="(item, index) in articleList">
          <!--<div>-->
          <!--  <span>{{item.title}}</span>-->
          <!--  <span>{{item.articleAbstract}}</span>-->
          <!--  <span>{{item.categoryName}}</span>-->
          <!--</div>-->
          <ArticleItem :article="item" :key="index"></ArticleItem>
        </template>
        <el-pagination v-show="total > 0" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum"
          :page-sizes="[5, 10, 20, 30, 50]" :page-size.sync="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getArticleList } from "@/api/articles";
import ArticleItem from "@/components/ArticleItem";
import { scrollToTop } from "@/utils/scrollTo";

export default {
  name: "Search",
  components: { ArticleItem },
  data() {
    return {
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      articleList: [],
      total: 0
    };
  },
  created() {
    // created()时不会触发watch，所以这里也需要查询一次
    this.getArticleList();
  },
  metaInfo() {
    return {
      title: "文章列表"
    }
  },
  computed: {
    categoryId() {
      return this.$store.getters.categoryId
    },
    searchValue() {
      return this.$store.getters.searchValue
    },
    search() {
      return this.$store.getters.search
    }
  },
  watch: {
    categoryId(newId) {
      // console.log(`new categoryId: ${newId}`)
      this.getArticleList()
    },
    search(newVal) {
      // console.log(`是否搜索：${newVal}`)
      if (newVal) {
        this.getArticleList()
      }
    }
  },
  methods: {
    handleSizeChange() {
      this.queryParams.pageNum = 1;
      this.getArticleList();
    },
    handleCurrentChange() {
      this.getArticleList();
    },
    getArticleList() {
      this.loading = true
      // 使用关键词搜索时不设置分类，选择分类时不使用关键词
      if (this.search) {
        this.$store.dispatch('article/setSearch', false)
        this.queryParams.categoryId = null
        this.queryParams.searchValue = this.searchValue;
      } else {
        this.queryParams.categoryId = this.categoryId;
        this.queryParams.searchValue = null;
      }
      getArticleList(this.queryParams).then(res => {
        // this.$modal.notifySuccess('查询成功')
        this.articleList = res.data.rows;
        this.total = res.data.total;
        scrollToTop();
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped></style>
